import { ClickAwayListener, Slide } from '@mui/material';
import { UcrClose, UcrViewList } from '@ucr/icons';
import { useCallback, useRef, useState } from 'react';
import { Link } from 'react-router';

import ImgPhotoEmptyMedic from 'shared/assets/photo-empty-medic.png';
import { Button } from 'shared/ui/Button';
import { IconWrapper } from 'shared/ui/IconWrapper';
import { Text } from 'shared/ui/Text';

import cls from './Account.module.scss';
import { accountMenu } from './accountMenu.const';

type AccountProps = {
  accountDetails: {
    /** Краткое ФИО */
    name: string;
    /** Ссылка на фото пользователя */
    photo?: string;
  };
};

export function Account(props: AccountProps) {
  const { accountDetails } = props;

  const refOpenAccount = useRef(false);
  const [isAccountOpen, setIsAccountOpen] = useState(false);

  const handleOpenAccount = () => {
    setIsAccountOpen((prev) => !prev);
  };

  const onClickAway = useCallback(() => {
    if (refOpenAccount.current) {
      setIsAccountOpen(false);
      refOpenAccount.current = false;
    }
  }, []);

  return (
    <>
      <div
        className={cls.Wrapper}
        tabIndex={0}
        role='button'
        onClick={() => handleOpenAccount()}
        onKeyDown={(e) => e.code === 'Enter' && handleOpenAccount()}
      >
        <div className={cls.Container}>
          <img
            className={cls.Photo}
            src={accountDetails.photo ?? ImgPhotoEmptyMedic}
            alt={accountDetails.name}
          />

          <Text variant='h6'>{accountDetails.name}</Text>
        </div>

        <div className={cls.MenuIcon}>
          <IconWrapper icon={isAccountOpen ? UcrClose : UcrViewList} />
        </div>
      </div>

      <Slide
        direction='up'
        in={isAccountOpen}
        mountOnEnter
        unmountOnExit
        addEndListener={() => {
          refOpenAccount.current = true;
        }}
      >
        <div className={cls.AccountMenuWrapper}>
          <ClickAwayListener onClickAway={onClickAway}>
            <div className={cls.AccountMenu}>
              {accountMenu.map((item) =>
                !item.disabled ? (
                  <Link
                    key={item.title + item.link}
                    to={item.link}
                    onClick={onClickAway}
                  >
                    <Button
                      key={item.title + item.link}
                      className={cls.AccountMenuItem}
                      variant='text'
                    >
                      <IconWrapper icon={item.icon} />

                      <Text variant='b1' className={cls.NavGroupTitle}>
                        {item.title}
                      </Text>
                    </Button>
                  </Link>
                ) : (
                  <Button
                    key={item.title + item.link}
                    className={cls.AccountMenuItem}
                    style={{ background: 'none' }}
                    disabled={item.disabled}
                    variant='text'
                  >
                    <IconWrapper icon={item.icon} />

                    <Text variant='b1' className={cls.NavGroupTitle}>
                      {item.title}
                    </Text>
                  </Button>
                ),
              )}
            </div>
          </ClickAwayListener>
        </div>
      </Slide>
    </>
  );
}
